// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import { __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import * as z from 'zod'

/**
 * This is a very basic schema to ensure the resolveResponse function from
 * the 'contentful-resolve-response' package returns an collection of objects
 * that somewhat resembles the shape of a Contentful entry.
 */
export const EntryCollection = /* @__PURE__ */ (() => {
var __zs=z.lazy(() => z.array(z.looseObject({})).min(1));
function __af_1(a){for(var __ae_0,i=0;i<a.length;i++){__ae_0=a[i];if(!(typeof __ae_0==="object"&&__ae_0!==null&&!Array.isArray(__ae_0))){return false;}}return true;}
function __fc_2(input){return Array.isArray(input)&&input.length>=1&&__af_1(input);}
var __bf_3={};
function __vb_8(input){var __ba_4,__bi_5,__be_6,__bs_7;if(!Array.isArray(input))return __bf_3;if(input.length<1)return __bf_3;__ba_4=new Array(input.length);for(__bi_5=0;__bi_5<input.length;__bi_5++){__be_6=input[__bi_5];if(!(typeof __be_6==="object"&&__be_6!==null&&!Array.isArray(__be_6)))return __bf_3;__bs_7=__zcPs(__be_6);__ba_4[__bi_5]=__bs_7;}return __ba_4;}
var __rfm_z=__zs.safeParse;
function safeParse_EntryCollection(input){
var __bd_9=__vb_8(input);
if(__bd_9!==__bf_3){return{success:true,data:__bd_9};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_EntryCollection,__zs,null,__fc_2);
})()

export type EntryCollection = z.infer<typeof EntryCollection>

export function toEntryCollection(collection: unknown): EntryCollection {
  return EntryCollection.parse(collection)
}
